import { useTranslation } from 'react-i18next';

type StatsPanelProps = {
  selectedSemenCount: number;
  uniqueSireNamesCount: number;
  totalUnitsToAdd: number;
};

export const StatsPanel = ({
  selectedSemenCount,
  uniqueSireNamesCount,
  totalUnitsToAdd,
}: StatsPanelProps) => {
  const { t } = useTranslation();

  return (
    <div className="rounded-lg bg-gray-100 p-4">
      <div className="grid grid-cols-3 gap-4 text-sm">
        <div>
          <span className="text-gray-600">{t('common.selected')}:</span>
          <span className="ml-2 font-semibold">{selectedSemenCount}</span>
        </div>
        <div>
          <span className="text-gray-600">{t('sire.uniqueSires')}:</span>
          <span className="ml-2 font-semibold">{uniqueSireNamesCount}</span>
        </div>
        <div>
          <span className="text-gray-600">{t('semen.unitsToAdd')}:</span>
          <span className="ml-2 font-semibold">{totalUnitsToAdd}</span>
        </div>
      </div>
    </div>
  );
};
